export const DOCUMENT_LENGTH: number = 0;

export const PROVIDER_STATUS: number = 3;

// Constants for Language
export const OTHER_LANG: number = 999;
export const ENGLISH_LANG: number = 55;

// Messages used across multiple components
export const SELECTED_LANG_MESSAGE: string =
  'The selected language of assessment does not match the home language.';

export const EVAL_ACTION_STATUS: number = 24;
export const EVAL_STATUS_PROVIDER_PARENT: number = 3;
export const EVAL_STATUS_INTERNAL: number = 2;

export const EVALUATOR_AGENCY: string = 'evaluatorAgency';
export const EVALUATOR_TYPE: string = 'evaluatorType';
export const EVALUATOR_NAME: string = 'evaluatorName';

// Indices used for arrays
export const FIRST_INDEX: number = 0;
export const SECOND_INDEX: number = 1;

export const ASSESSMENTS: string = 'assessments';

export const CONTENT: string =
  'There is an error while uploading the document(s). Please try again.';

export const DOCUMENT_UPLOAD_SUCCESS: string =
  'Document(s) uploaded successfully.';

export const CASE_CHANGER: string =
  'The Case Manager will receive notification to close the Initial Referral, and they will send the PWN: Refusal of Request to Conduct Initial Evaluation and any other necessary documentation (copy of Request for Initial Referral, Parent’s right to make an initial referral, opportunity to discuss the Request for Initial Referral) to the Parent/Guardian.';

export const OCCUPATIONAL_THERAPY_ASSESSMENT: string =
  'Occupational Therapy Assessment';

export const PSYCHOLOGICAL_ASSESSMENT: string = 'Psychological Assessment';

export const SOCIAL_HISTORY_EVALUATION: string = 'Social History Evaluation';

export const PHYSICAL_EXAMINATION: string = 'Physical Examination';

export enum AssessmentStatus {
  Finalised = 24,
  FourtyOne = 41,
  FourtyTwo = 42,
}

